import React from 'react';
import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';

const FetchRoom = props => {
    return (
        <View style={Styles.wrapper}>
            <Text> ماژول ها </Text>
        </View>
    )
};

const Styles = StyleSheet.create({
    wrapper:{
        justifyContent:'center',
        alignItems: 'center'
    }
});

export default FetchRoom;